/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:55:27
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/code.js
 */

export default {
    // code 组件
    code: {
        seconds: 60,
        startText: '获取验证码',
        changeText: 'X秒重新获取',
        endText: '重新获取',
        keepRunning: false,
        uniqueKey: ''
    }
}
